webpackJsonp([227216412723404],{

/***/ 279:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  align-items: stretch;\n\n  @media (max-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    }\n  }\n"], ["\n  align-items: stretch;\n\n  @media (max-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  ", ";\n"], ["\n  ", ";\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _polished = __webpack_require__(8);
	
	var _components = __webpack_require__(7);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var UpdateLayout = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject, function (props) {
	  return props.theme.space[1];
	}, function (props) {
	  return props.theme.space[0];
	}, function (props) {
	  return "calc(" + 1 / 2 * 100 + "% - " + props.theme.space[4] / 2 + "px)";
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[0];
	});
	
	var CustomText = (0, _styledComponents2.default)(_components.Text)(_templateObject2, (0, _polished.wordWrap)("break-word"));
	
	var Prismic = __webpack_require__(36);
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Staff = function (_React$Component) {
	  _inherits(Staff, _React$Component);
	
	  function Staff(props) {
	    _classCallCheck(this, Staff);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.getUpdates = function (add) {
	      var predicates = [Prismic.Predicates.at("document.type", "update"), Prismic.Predicates.at("my.update.author", _this.props.data.staff.prismicId), Prismic.Predicates.not("my.update.uid", "hidden-update")];
	      var page = 1;
	      if (add) {
	        page = _this.state.updatePage + 1;
	      }
	      Prismic.getApi("https://bankinformationcenter.cdn.prismic.io/api/v2").then(function (api) {
	        return api.query(predicates, {
	          lang: _this.props.data.staff.lang,
	          fetchLinks: "region.uid",
	          page: page,
	          pageSize: _this.state.updateLimit,
	          orderings: "[my.update.publish_date desc]"
	        });
	      }).then(function (response) {
	        if (!add) {
	          _this.setState({ updates: response.results, updatePage: 1 });
	        } else {
	          var updatesCurrent = JSON.parse(JSON.stringify(_this.state.updates));
	          var updates = updatesCurrent.concat(response.results);
	          _this.setState({ updates: updates, updatePage: page });
	        }
	      });
	    };
	
	    _this.state = {
	      updates: [],
	      updateLimit: 12,
	      updatePage: 1
	    };
	    return _this;
	  }
	
	  Staff.prototype.componentDidMount = function componentDidMount() {
	    this.context.setAltLanguages(undefined);
	    this.getUpdates();
	  };
	
	  Staff.prototype.render = function render() {
	    var _this2 = this;
	
	    var json = "";
	    if (this.props.data.staff.raw) {
	      json = JSON.parse(this.props.data.staff.raw);
	    }
	    return _react2.default.createElement(
	      "div",
	      {
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      _react2.default.createElement(_components.Head, {
	        source: {
	          meta_title: [{
	            text: json.data.title !== undefined ? json.data.title[0] ? json.data.title[0].text + " | Bank Information Center" : "" : ""
	          }],
	          meta_description: [{
	            text: json.data.description !== undefined ? json.data.description[0] ? json.data.description[0].text : "" : ""
	          }],
	          social_sharing_image: {
	            url: json.data.header_image !== undefined ? json.data.header_image.url : ""
	          }
	        }
	      }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        _react2.default.createElement(
	          _components.PageHeader,
	          { title: json.data.title[0].text, color: json.type },
	          json.data.subtitle[0] && _react2.default.createElement(_components.Text, { children: json.data.subtitle[0].text })
	        ),
	        _react2.default.createElement(
	          _components.PageSection,
	          null,
	          _react2.default.createElement(
	            _components.PageSidebar,
	            { mobileTop: "true" },
	            _react2.default.createElement(
	              _rebass.Flex,
	              {
	                flexDirection: ["column", "row", null, "column"],
	                mt: [-48, null, null, 0],
	                mx: [0, -32, -48, 0]
	              },
	              json.data.header_image.url && _react2.default.createElement(
	                _rebass.Box,
	                {
	                  flex: "!",
	                  width: ["initial", 1 / 2, 1 / 1],
	                  mx: [-24, 0],
	                  mb: [0, null, null, 2]
	                },
	                _react2.default.createElement(_rebass.Image, {
	                  srcSet: json.data.header_image.quarter.url + " 1000w, " + json.data.header_image.half.url + " 2000w, " + json.data.header_image.url + " 2500w",
	                  w: "100%",
	                  alt: "Headshot of " + json.data.title[0].text
	                })
	              ),
	              _react2.default.createElement(
	                _rebass.Box,
	                {
	                  flex: "!",
	                  width: ["initial", 1 / 2, 1 / 1],
	                  mx: [-24, 0],
	                  px: 4,
	                  py: 5,
	                  bg: "grey.1"
	                },
	                json.data.phone && _react2.default.createElement(
	                  _rebass.Box,
	                  { mb: 4 },
	                  _react2.default.createElement(_components.H4, {
	                    children: json.lang === "en-us" ? "Phone" : json.lang === "es-mx" ? "Teléfono" : "الهاتف",
	                    mb: 1
	                  }),
	                  _react2.default.createElement(CustomText, { children: json.data.phone })
	                ),
	                json.data.email && _react2.default.createElement(
	                  _rebass.Box,
	                  null,
	                  _react2.default.createElement(_components.H4, {
	                    children: json.lang === "en-us" ? "Email" : json.lang === "es-mx" ? "E-mail" : "البريد الإلكتروني",
	                    mb: 1
	                  }),
	                  _react2.default.createElement(
	                    CustomText,
	                    null,
	                    _react2.default.createElement(
	                      "a",
	                      { href: "mailto:" + json.data.email },
	                      json.data.email
	                    )
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            _react2.default.createElement(
	              _rebass.Box,
	              null,
	              json.data.description && _react2.default.createElement(_components.Article, {
	                dangerouslySetInnerHTML: {
	                  __html: _prismicDom.RichText.asHtml(json.data.description, linkResolver)
	                }
	              }),
	              _react2.default.createElement(
	                _rebass.Box,
	                { mt: 4 },
	                _react2.default.createElement(_components.Button, {
	                  children: json.lang === "en-us" ? "Meet the whole team" : json.lang === "es-mx" ? "Conoce a todo el equipo" : "قابل الفريق بأكمله",
	                  is: _gatsbyLink2.default,
	                  to: "/" + json.lang + "/team"
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _components.PageSection,
	          { borderTop: "true", column: "true" },
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            _react2.default.createElement(_components.H2, {
	              children: json.lang === "en-us" ? "Updates by " + json.data.title[0].text : json.lang === "es-mx" ? "Actualizaciones de " + json.data.title[0].text : "تحديثات بواسطة " + json.data.title[0].text,
	              mb: 5,
	              fontSize: [4, 5]
	            }),
	            this.state.updates && _react2.default.createElement(
	              UpdateLayout,
	              null,
	              this.state.updates.map(function (update, index) {
	                return _react2.default.createElement(_components.UpdateCard, {
	                  key: "update" + index,
	                  object: update,
	                  institutions: _this2.props.data.institutions.edges,
	                  campaigns: _this2.props.data.campaigns.edges
	                });
	              })
	            ),
	            this.state.updates.length !== this.state.updateLimit * this.state.updatePage && _react2.default.createElement(
	              _rebass.Flex,
	              { width: "100%", justify: "center" },
	              _react2.default.createElement(
	                _rebass.Box,
	                { pt: 6, style: { textAlign: "center" } },
	                _react2.default.createElement(_components.Text, {
	                  children: json.lang === "en-us" ? "Didn't find what you are looking for?" : json.lang === "es-mx" ? "¿No encontró lo que estaba buscando?" : "لم تجد ما تبحث عنه؟",
	                  mb: 3
	                }),
	                _react2.default.createElement(_components.PrimaryButton, {
	                  children: json.lang === "en-us" ? "Get in touch" : json.lang === "es-mx" ? "Póngase en contacto" : "اتصل بنا",
	                  is: _gatsbyLink2.default,
	                  to: "/" + json.lang + "/contact"
	                })
	              )
	            ),
	            this.state.updates.length === this.state.updateLimit * this.state.updatePage && _react2.default.createElement(
	              _rebass.Flex,
	              { width: "100%", justify: "center" },
	              _react2.default.createElement(
	                _rebass.Box,
	                { pt: 6 },
	                _react2.default.createElement(_components.PrimaryButton, {
	                  children: json.lang === "en-us" ? "View More" : json.lang === "es-mx" ? "Ver más" : "عرض المزيد",
	                  onClick: function onClick() {
	                    _this2.getUpdates(true);
	                  }
	                })
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Staff;
	}(_react2.default.Component);
	
	Staff.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Staff;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-staff-js-92cba5780947df71c098.js